(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('UserController', UserController);

    UserController.$inject = ['$scope', 'UserData'];

    function UserController($scope, UserData) {
        var vm = this;

        vm.groupName = UserData.groupName;
    }
})();